import {EStatus} from './definitions';

export default {
  status: {
    [EStatus.DRAFT]: 'Черновик',
    [EStatus.IN_PROGRESS]: 'На регистрации',
    [EStatus.CREATE_SUBJECT]: 'На регистрации',
    [EStatus.CREATE_SUBJECT_ERROR]: 'Проблема',
    [EStatus.CANCELLED]: 'Отключен',
    [EStatus.DONE]: 'Работает исправно',
  },
  editForm: {
    settings: 'Настройки канала',
    subject: 'Отправитель',
    subjectHint:
      'Отправитель — системное имя канала, используется внутри edna Pulse и не отображается получателям',
    name: 'Внутреннее название канала',
    nameHint: 'Это название будет отображаться в списке каналов edna Pulse и в отчетности',
    token: 'Токен доступа',
    tokenHint: 'Вставьте access_token для бота',
    sendingInfo:
      'Отправлять сообщения в канал MAX Bot можно только после получения входящего сообщения от получателя. Для обмена сообщениями используется только MAX_ID',
  },
  registrationCheck: {
    title: 'Необходимые шаги для регистрации MAX Bot:',
    points: [
      'Пройдите регистрацию в MAX. <1>Упрощенная регистрация в MAX через edna</1> <0></0> не требует подтверждения через сервисы RuStore или платформу МСП',
      'Вы прошли <2>верификацию в MAX</2> <0></0>',
      'Вы создали чат-бота в разделе "Чат-бот и мини-приложение". <3>Как создать бота в MAX</3> <0></0>',
      'Вы получили токен вашего чат-бота в разделе “Интеграция” в личном кабинете MAX',
    ],
  },
};
